import cx from 'classnames';
import type { MouseEvent, VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../../../generic';
import Button, { BUTTON_TYPE } from '../../../../../generic/Button';

import styles from './StateContextPanel.module.less';

type Props = {
  setBuildId: (buildId: number | null) => void;
  buildId: number | null;
};

const BuildStatePanel: VoidFunctionComponent<Props> = ({
  setBuildId,
  buildId,
}) => {
  const openBuildModal = (event: MouseEvent<HTMLElement, MouseEvent>) => {
    setBuildId(buildId);

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <div className={cx(styles.stateContextPanel, styles.buildState)}>
      {buildId ?
        <>
          Queued: Build #{buildId}
          <Button type={BUTTON_TYPE.ANCHOR} onClick={openBuildModal}>
            <div className={styles.iconLink}>
              <span>View build</span>
              <Icon icon={icons.personDigging} />
            </div>
          </Button>
        </>
        : <>Not Building</>}
    </div>
  );
};

export default BuildStatePanel;
